"use strict";

var _editions_map = _interopRequireWildcard(require("./editions_map"));

var _productOrEditionHomepageUrl = require("./productOrEditionHomepageUrl");

var _absSubMenuLinks = require("./absSubMenuLinks");

var _subscriptionTagsMap = _interopRequireDefault(require("./subscriptionTagsMap"));

var _ramda = require("ramda");

var _deepFreeze;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var deepFreeze = require('deep-freeze');

var EDITIONS_ARRAY = deepFreeze(Object.keys(_editions_map["default"]).map(function (key) {
  return _editions_map["default"][key];
}));
var DEBTWIRE_CORE_EDITIONS = deepFreeze([_editions_map["default"].EUROPE, _editions_map["default"].NORTH_AMERICA, _editions_map["default"].LATIN_AMERICA, _editions_map["default"].ASIA_PACIFIC, _editions_map["default"].CEEMEA]);
var DEBTWIRE_PREMIUM_EDITIONS = deepFreeze([_editions_map["default"].MIDDLE_MARKET, _editions_map["default"].MIDDLE_MARKET_EUROPE]);
var XTRACT_EDITIONS = deepFreeze([_editions_map["default"].XTRACT_EUROPE, _editions_map["default"].XTRACT_NORTH_AMERICA, _editions_map["default"].XTRACT_ASIA_PACIFIC]);
var ABS_EDITIONS = deepFreeze([_editions_map["default"].ABS_EUROPE, _editions_map["default"].ABS_NORTH_AMERICA]);
var DEBTWIRE_PRODUCTS = deepFreeze(DEBTWIRE_PREMIUM_EDITIONS.concat(ABS_EDITIONS).concat(_editions_map["default"].MUNICIPALS));
var DEBTWIRE_COMPANY_DIRECTORY_EDITIONS_SUBSET = deepFreeze(DEBTWIRE_CORE_EDITIONS.concat(_editions_map["default"].MIDDLE_MARKET).concat(_editions_map["default"].MIDDLE_MARKET_EUROPE).concat(_editions_map["default"].LITIGATION_FINANCE));
var PREMIUM_TO_STANDARD_EDITION = deepFreeze((_deepFreeze = {}, _defineProperty(_deepFreeze, _editions_map["default"].MIDDLE_MARKET_EUROPE.id, _editions_map["default"].EUROPE.id), _defineProperty(_deepFreeze, _editions_map["default"].MIDDLE_MARKET.id, _editions_map["default"].NORTH_AMERICA.id), _deepFreeze));
var PRIMARY_ISSUANCE_EDITIONS = deepFreeze([_editions_map["default"].PRIMARY_ISSUANCE_EUROPE, _editions_map["default"].PRIMARY_ISSUANCE_NORTH_AMERICA, _editions_map["default"].PRIMARY_ISSUANCE_ASIA_PACIFIC, _editions_map["default"].PRIMARY_ISSUANCE_LATIN_AMERICA, _editions_map["default"].PRIMARY_ISSUANCE_EEMEA, _editions_map["default"].PRIMARY_ISSUANCE_MIDDLE_MARKET, _editions_map["default"].PRIMARY_ISSUANCE_MIDDLE_MARKET_EUROPE]);
var LITIGATION_FINANCE_EDITIONS = deepFreeze([_editions_map["default"].LITIGATION_FINANCE]);

function isInCollection(collection, matchEdition) {
  switch (_typeof(matchEdition)) {
    case 'string':
      return collection.some(function (edition) {
        return edition.id === matchEdition;
      });

    case 'object':
      return collection.some(function (edition) {
        return deepEqual(edition, matchEdition);
      });

    default:
      throw Error("not an edition object or an id string ".concat(JSON.stringify(matchEdition)));
  }
}

function deepEqual(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}

function isDebtwireCore(edition) {
  return isInCollection(DEBTWIRE_CORE_EDITIONS, edition);
}

function isPrimaryIssuance(edition) {
  return isInCollection(PRIMARY_ISSUANCE_EDITIONS, edition);
}

function isLitigationFinance(edition) {
  return isInCollection(LITIGATION_FINANCE_EDITIONS, edition);
}

function isPremium(edition) {
  return isInCollection(DEBTWIRE_PREMIUM_EDITIONS, edition);
}

function isXtract(edition) {
  return isInCollection(XTRACT_EDITIONS, edition);
}

function isAbs(edition) {
  return isInCollection(ABS_EDITIONS, edition);
}

function isMuni(edition) {
  return isInCollection([_editions_map["default"].MUNICIPALS], edition);
}

function isEntitledOnlyToAbsMuniPrimaryIssuanceOrXtract(editions) {
  return (0, _ramda.all)(isAbsOrMuniOrPrimaryIssuanceOrXtract)(editions);
}

function isEntitledToLitigationFinance(editions) {
  return (0, _ramda.any)(isLitigationFinance)(editions);
}

function isAbsOrMuniOrPrimaryIssuanceOrXtract(edition) {
  return isAbs(edition) || isMuni(edition) || isPrimaryIssuance(edition) || isXtract(edition);
}

module.exports = {
  EDITIONS: deepFreeze(Object.assign(EDITIONS_ARRAY.slice(0), _editions_map["default"])),
  EDITIONS_MAP: _editions_map["default"],
  EDITIONS_ARRAY: EDITIONS_ARRAY,
  HOMEPAGES: _productOrEditionHomepageUrl.HOMEPAGES,
  SUBSCRIPTION_TAGS_MAP: _subscriptionTagsMap["default"],
  DEBTWIRE_CORE_EDITIONS: DEBTWIRE_CORE_EDITIONS,
  DEBTWIRE_PREMIUM_EDITIONS: DEBTWIRE_PREMIUM_EDITIONS,
  DEBTWIRE_PRODUCTS: DEBTWIRE_PRODUCTS,
  DEBTWIRE_COMPANY_DIRECTORY_EDITIONS_SUBSET: DEBTWIRE_COMPANY_DIRECTORY_EDITIONS_SUBSET,
  PRODUCTS: _editions_map.PRODUCTS,
  XTRACT_EDITIONS: XTRACT_EDITIONS,
  ABS_EDITIONS: ABS_EDITIONS,
  PRIMARY_ISSUANCE_EDITIONS: PRIMARY_ISSUANCE_EDITIONS,
  LITIGATION_FINANCE_EDITIONS: LITIGATION_FINANCE_EDITIONS,
  PREMIUM_TO_STANDARD_EDITION: PREMIUM_TO_STANDARD_EDITION,
  JOINED_ABS_ID: ABS_EDITIONS.map(function (edition) {
    return edition.id;
  }).join('__'),
  isDebtwireCore: isDebtwireCore,
  isPremium: isPremium,
  isXtract: isXtract,
  isAbs: isAbs,
  isEntitledOnlyToAbsMuniPrimaryIssuanceOrXtract: isEntitledOnlyToAbsMuniPrimaryIssuanceOrXtract,
  isEntitledToLitigationFinance: isEntitledToLitigationFinance,
  ABSSubMenuLinks: _absSubMenuLinks.ABSSubMenuLinks,
  hasNPLAccess: _absSubMenuLinks.hasNPLAccess
};